/**
 * Пак «По-домашнему» — фоны и шаги `state_desktop_*` / `state_mobile_*` в `packs/domashniy/`.
 */
import domashniyBgDesktop from '@/assets/img/rice-game/packs/domashniy/bg-desktop.jpg';
import domashniyBgDesktop2x from '@/assets/img/rice-game/packs/domashniy/bg-desktop@2x.jpg';
import domashniyBgMobile from '@/assets/img/rice-game/packs/domashniy/bg-mobile.jpg';
import domashniyBgMobile2x from '@/assets/img/rice-game/packs/domashniy/bg-mobile@2x.jpg';

import domashniyStateD01 from '@/assets/img/rice-game/packs/domashniy/state_desktop_1.png';
import domashniyStateD02 from '@/assets/img/rice-game/packs/domashniy/state_desktop_2.png';
import domashniyStateD03 from '@/assets/img/rice-game/packs/domashniy/state_desktop_3.png';
import domashniyStateD04 from '@/assets/img/rice-game/packs/domashniy/state_desktop_4.png';
import domashniyStateD05 from '@/assets/img/rice-game/packs/domashniy/state_desktop_5.png';
import domashniyStateD06 from '@/assets/img/rice-game/packs/domashniy/state_desktop_6.png';
import domashniyStateD07 from '@/assets/img/rice-game/packs/domashniy/state_desktop_7.png';
import domashniyStateD08 from '@/assets/img/rice-game/packs/domashniy/state_desktop_8.png';
import domashniyStateD09 from '@/assets/img/rice-game/packs/domashniy/state_desktop_9.png';
import domashniyStateD10 from '@/assets/img/rice-game/packs/domashniy/state_desktop_10.png';
import domashniyStateD11 from '@/assets/img/rice-game/packs/domashniy/state_desktop_11.png';
import domashniyStateD12 from '@/assets/img/rice-game/packs/domashniy/state_desktop_12.png';
import domashniyStateD13 from '@/assets/img/rice-game/packs/domashniy/state_desktop_13.png';
import domashniyStateD14 from '@/assets/img/rice-game/packs/domashniy/state_desktop_14.png';
import domashniyStateD15 from '@/assets/img/rice-game/packs/domashniy/state_desktop_15.png';
import domashniyStateD16 from '@/assets/img/rice-game/packs/domashniy/state_desktop_16.png';

import domashniyStateM01 from '@/assets/img/rice-game/packs/domashniy/state_mobile_1.png';
import domashniyStateM02 from '@/assets/img/rice-game/packs/domashniy/state_mobile_2.png';
import domashniyStateM03 from '@/assets/img/rice-game/packs/domashniy/state_mobile_3.png';
import domashniyStateM04 from '@/assets/img/rice-game/packs/domashniy/state_mobile_4.png';
import domashniyStateM05 from '@/assets/img/rice-game/packs/domashniy/state_mobile_5.png';
import domashniyStateM06 from '@/assets/img/rice-game/packs/domashniy/state_mobile_6.png';
import domashniyStateM07 from '@/assets/img/rice-game/packs/domashniy/state_mobile_7.png';
import domashniyStateM08 from '@/assets/img/rice-game/packs/domashniy/state_mobile_8.png';
import domashniyStateM09 from '@/assets/img/rice-game/packs/domashniy/state_mobile_9.png';
import domashniyStateM10 from '@/assets/img/rice-game/packs/domashniy/state_mobile_10.png';
import domashniyStateM11 from '@/assets/img/rice-game/packs/domashniy/state_mobile_11.png';
import domashniyStateM12 from '@/assets/img/rice-game/packs/domashniy/state_mobile_12.png';
import domashniyStateM13 from '@/assets/img/rice-game/packs/domashniy/state_mobile_13.png';
import domashniyStateM14 from '@/assets/img/rice-game/packs/domashniy/state_mobile_14.png';
import domashniyStateM15 from '@/assets/img/rice-game/packs/domashniy/state_mobile_15.png';
import domashniyStateM16 from '@/assets/img/rice-game/packs/domashniy/state_mobile_16.png';

export const domashniyBackgrounds = {
  backgroundDesktop: domashniyBgDesktop,
  backgroundDesktop2x: domashniyBgDesktop2x,
  backgroundMobile: domashniyBgMobile,
  backgroundMobile2x: domashniyBgMobile2x,
};

export const domashniyFramesDesktop = [
  domashniyStateD01,
  domashniyStateD02,
  domashniyStateD03,
  domashniyStateD04,
  domashniyStateD05,
  domashniyStateD06,
  domashniyStateD07,
  domashniyStateD08,
  domashniyStateD09,
  domashniyStateD10,
  domashniyStateD11,
  domashniyStateD12,
  domashniyStateD13,
  domashniyStateD14,
  domashniyStateD15,
  domashniyStateD16,
];

export const domashniyFramesMobile = [
  domashniyStateM01,
  domashniyStateM02,
  domashniyStateM03,
  domashniyStateM04,
  domashniyStateM05,
  domashniyStateM06,
  domashniyStateM07,
  domashniyStateM08,
  domashniyStateM09,
  domashniyStateM10,
  domashniyStateM11,
  domashniyStateM12,
  domashniyStateM13,
  domashniyStateM14,
  domashniyStateM15,
  domashniyStateM16,
];
